// ** Icons Import
import {Home, Circle} from 'react-feather'

export default [
    {
        id: 'dashboards',
        title: 'navigation.home',
        icon: <Home size={20}/>,
        navLink: '/dashboard',
        action: 'ROLE_DASHBOARD',
        resource: 'IS_GRANTED'
    }
]